import { components, DropdownIndicatorProps, GroupBase } from "react-select"
import Icon from "lib/components/Icons"
import { SELECT_TOKENS } from "lib/components/Form/selectStyles"

/**
 * Replaces react-select's 20px chevron with the 16px design-system glyph. Wraps `components.DropdownIndicator`
 * so the `react-select__dropdown-indicator` class and the `dropdownIndicator` style key keep working.
 */
function SelectChevron<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>,
) {
  return (
    <components.DropdownIndicator {...props}>
      <Icon iconName="expand-more" width={16} height={16} color={SELECT_TOKENS.placeholder} />
    </components.DropdownIndicator>
  )
}

export default SelectChevron
